function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.075,17.789c0.478,0.479,0.478,1.254,0,1.732l-9.89,9.891h5.705c0.678,0,1.225,0.549,1.225,1.227  s-0.547,1.225-1.225,1.225H1.226C0.549,31.863,0,31.316,0,30.639v-8.666c0-0.676,0.549-1.225,1.226-1.225  c0.678,0,1.227,0.549,1.227,1.225v5.709l9.89-9.893c0.239-0.238,0.553-0.359,0.865-0.359C13.521,17.43,13.835,17.551,14.075,17.789z   M30.774,0.137H22.11c-0.678,0-1.226,0.547-1.226,1.225s0.548,1.227,1.226,1.227h5.705L17.79,12.615  c-0.479,0.479-0.479,1.254,0,1.732c0.478,0.479,1.253,0.479,1.732,0L29.548,4.32v5.707c0,0.676,0.549,1.225,1.227,1.225  c0.677,0,1.226-0.549,1.226-1.225V1.361C32,0.684,31.451,0.137,30.774,0.137z"
});
const SvgIconMaximize = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMaximize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-maximize.86f3ce4a.svg";
export { ForwardRef as ReactComponent };